import { render, staticRenderFns } from "./basicInformation.vue?vue&type=template&id=5443b970&scoped=true"
import script from "./basicInformation.vue?vue&type=script&lang=js"
export * from "./basicInformation.vue?vue&type=script&lang=js"
import style0 from "./basicInformation.vue?vue&type=style&index=0&id=5443b970&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5443b970",
  null
  
)

export default component.exports